import { ICommand } from 'core-ts-types';
import { SectionSwapModel } from '../models/course_section_swap_model';
import { ISection } from '../../interfaces/scheduler_interfaces';
import { SectionSwapServant } from '../servants/section_swap_servant';
import { RegistrationAlertsServant } from '../../views/course_scheduler/servants/registration_alerts_servant';
import { SwapErrorStrategy } from '../strategies/swap_strategy';
import * as _4 from 'lodash4';

export class SwapFacade {
  constructor(
    private saveSwapToSectionCommand: ICommand,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngSectionSwapServant: SectionSwapServant,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngRegistrationAlertsServant: RegistrationAlertsServant,
    private $timeout: ng.ITimeoutService
  ) {}
  saveSwapToAndRedirect(section: ISection) {
    this.saveSwapToSectionCommand(section)
      .then(() => {
        this.$timeout(() => {
          const swappingToSectionEl = document.querySelector(`section-swap-preview #section-${section.cd}`);
          if (swappingToSectionEl) {
            swappingToSectionEl.scrollIntoView({ behavior: 'smooth' });
          }
        }, 0);

        const isSwapCourse = _4.isEqual(_4.get(this.$stateParams, 'swapCourse', 'false'), 'true');
        const notificationText = `New ${isSwapCourse ? 'course' : 'section time'} added to swap`;

        this.ngRegistrationAlertsServant.createGenericNotification(notificationText, 'success');

        if (this.ngCourseSectionSwapModel.read().isMultiSection) {
          this.$state.go(`my.schedule.registration.swap.sectionTypeList`, {
            courseId: section.course,
            sectionTypeId: section.section_type,
            ignoreConflicts: true,
            swapCourse: isSwapCourse
          });
        }
      })
      .catch((e) => {
        this.ngRegistrationAlertsServant.createGenericNotification(SwapErrorStrategy[e.error].text, 'error');
      });
  }
}
angular.module('capability-ng-scheduler').service('ngSwapFacade', SwapFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/facades/swap_facade.ts